import { useCallback } from 'react';
import { NavigateOptions, To, useLocation, useNavigate } from 'react-router-dom';

/**
 * Allows you to navigate through routes without losing URL query parameters.
 */
export default function useNavigateWithSearch() {
    const location = useLocation();
    const navigate = useNavigate();
    
    const navigateWithSearch = useCallback((to: Omit<To, 'search'>, options?: NavigateOptions) => {
        if (typeof to === 'number') {
            navigate(to);
        }

        const path = typeof to === 'string' ? { pathname: to } : to;

        navigate({
            ...path,
            search: location.search
        }, options);
    }, [ location, navigate ]);

    return navigateWithSearch;
}
